export default {
  kameraplaner: {
    intro: {
      badge: 'Outil de planification interactif – gratuit et sans engagement',
      title: 'Planifiez votre système de caméras à l’avance',
      lead:
        'Avec le planificateur de caméras SSG, vous pouvez dessiner des pièces ou des surfaces, marquer des portes, fenêtres et zones de surveillance importantes, et tester des positions de caméra possibles. Vous obtenez une première évaluation visuelle qui pourra ensuite être vérifiée professionnellement par SSG Signaltechnik.',
      noReg: 'Sans inscription',
      localSave: 'Enregistré localement dans le navigateur',
      noBinding: 'Aucun nombre contraignant de caméras',
      quickTitle: 'Lancer la vérification rapide',
      quickDesc:
        'Répondez en cinq étapes courtes à des questions sur votre bien, les zones de surveillance et les fonctions souhaitées. Vous obtenez immédiatement un résumé clair.',
      quickList: { '0': 'Type de bien et zones à surveiller', '1': 'Fonctions souhaitées et données du bien', '2': 'Résumer le résultat et l’envoyer directement' },
      quickCta: 'Lancer la vérification rapide',
      plannerTitle: 'Planifier vous-même le plan',
      plannerDesc:
        'Dessinez des pièces et des murs, placez portes, fenêtres, obstacles et caméras, avec cônes de vision, analyse de couverture et suggestions automatiques de positions.',
      plannerList: { '0': 'Surface de dessin avec grille et échelle en mètres', '1': 'Cônes de vision, cibles de surveillance et zones privées', '2': 'Import de plan, évaluation et impression' },
      plannerCta: 'Planifier vous-même le plan',
      savedTitle: 'Une planification enregistrée existe',
      savedDesc: 'Elle a été enregistrée automatiquement localement et peut être poursuivie.',
      resume: 'Reprendre la dernière planification',
    },
    quick: {
      steps: { '0': 'Type de bien', '1': 'Zones', '2': 'Fonctions', '3': 'Données du bien', '4': 'Résultat' },
      back: 'Retour à l’aperçu',
      title: 'Vérification rapide',
      subtitle: 'Cinq étapes courtes; vous recevez ensuite un résumé clair de votre planification préliminaire.',
      stepOf: 'Étape {{current}} sur {{total}}',
      objectQuestion: 'Quel type de bien vous convient?',
      chooseOne: 'Veuillez sélectionner une option.',
      areasQuestion: 'Quelles zones doivent être surveillées?',
      multiSelect: 'Sélection multiple possible.',
      featuresTitle: 'Fonctions souhaitées',
      dataTitle: 'Données du bien',
      dataOptional: 'Toutes les informations sont facultatives et peuvent être ignorées.',
      areaSize: 'Surface totale approximative (m²)',
      roomCount: 'Nombre de pièces ou de zones',
      inOut: 'Intérieur, extérieur ou les deux?',
      inside: 'Intérieur',
      outside: 'Extérieur',
      both: 'Les deux',
      maxDistance: 'Plus grande distance de surveillance estimée',
      pleaseSelect: 'Veuillez sélectionner',
      distanceUpTo5: 'Jusqu’à 5 mètres',
      distance5to10: '5 à 10 mètres',
      distance10to20: '10 à 20 mètres',
      distanceOver20: 'Plus de 20 mètres',
      internet: 'Connexion internet disponible?',
      network: 'Câblage réseau disponible?',
      power: 'Courant au point de montage?',
      yes: 'Oui',
      no: 'Non',
      unknown: 'Inconnu',
      recordingDuration: 'Durée d’enregistrement souhaitée',
      installType: 'Nouvelle installation ou système existant?',
      newSystem: 'Nouvelle installation',
      existingSystem: 'Système existant',
      existingManufacturer: 'Fabricant et modèle du système existant (si connu)',
      requirements: 'Exigences particulières',
      requirementsPlaceholder: 'Par exemple conditions d’éclairage particulières, protection du patrimoine, prescriptions spéciales...',
      chars: '{{current}}/500 caractères',
      ssgCarePre: 'Je m’intéresse en outre à',
      ssgCarePost: '– maintenance et accompagnement personnel de l’installation.',
      overviewTitle: 'Votre planification préliminaire en un coup d’œil',
      amberNote:
        'D’après vos informations, plusieurs positions ou types de caméra peuvent convenir. Pour une recommandation fiable, angles de vision, hauteur de montage, éclairage et obstacles existants doivent être vérifiés.',
      planFloorplan: 'Planifier en plus le plan',
      sendToSsg: 'Envoyer les données à SSG',
      editResult: 'Modifier le résultat',
      backBtn: 'Retour',
      next: 'Suivant',
      summary: {
        objectType: 'Type de bien',
        areas: 'Zones de surveillance',
        features: 'Fonctions souhaitées',
        areaSize: 'Surface totale approximative',
        roomCount: 'Pièces / zones',
        inOut: 'Zone',
        maxDistance: 'Plus grande distance de surveillance',
        internet: 'Connexion internet',
        network: 'Câblage réseau',
        power: 'Courant au point de montage',
        recordingDuration: 'Durée d’enregistrement',
        installType: 'Installation',
        existingSystem: 'Système existant',
        requirements: 'Exigences particulières',
        ssgCare: 'Accompagnement SSG Care',
      },
      values: {
        notSpecified: 'Non spécifié',
        inside: 'Intérieur',
        outside: 'Extérieur',
        inOut: 'Intérieur et extérieur',
        present: 'Disponible',
        notPresent: 'Non disponible',
        unknown: 'Inconnu',
        unclear: 'encore incertain',
        newSystem: 'Nouvelle installation',
        existing: 'Système existant',
        desired: 'Souhaité',
      },
    },
    topbar: {
      projectName: 'Nom du projet',
      undo: 'Annuler',
      undoTip: 'Annuler (Ctrl+Z)',
      redo: 'Rétablir',
      redoTip: 'Rétablir (Ctrl+Y)',
      save: 'Sauvegarder temporairement',
      saved: 'Enregistré',
      saveTip: 'Sauvegarder temporairement',
      reset: 'Réinitialiser',
      resetTip: 'Réinitialiser le planificateur',
      help: 'Aide',
      helpTip: 'Rouvrir l’introduction',
      evaluate: 'Évaluer la planification',
      evaluateTip: 'Évaluer la planification',
    },
    tools: {
      select: { label: 'Sélectionner', hint: 'Déplacer, redimensionner, faire pivoter les éléments. Faire glisser une zone vide = déplacer.' },
      erase: { label: 'Supprimer', hint: 'Supprimer un élément en cliquant.' },
      room: { label: 'Pièce rectangulaire', hint: 'Dessiner une pièce ou une surface en faisant glisser – les dimensions s’affichent en direct.' },
      polygon: { label: 'Surface libre', hint: 'Dessiner une surface libre à main levée : maintenir le bouton et tracer la forme.' },
      wall: { label: 'Mur', hint: 'Dessiner un mur en faisant glisser – limite les lignes de vision.' },
      door: { label: 'Porte', hint: 'Placer une porte sur un mur – puis déplacer ou pivoter directement.' },
      window: { label: 'Fenêtre', hint: 'Placer une fenêtre sur un mur – puis déplacer ou pivoter directement.' },
      obstacle: { label: 'Obstacle', hint: 'Dessiner une colonne, étagère, cloison ou bloc de meubles.' },
      watch: { label: 'Cible de surveillance', hint: 'Marquer une zone importante à capter.' },
      privacy: { label: 'Zone privée', hint: 'Marquer une zone à ne pas capter.' },
      camera: { label: 'Caméra', hint: 'Placer une caméra en cliquant. Le menu des modèles s’ouvre à droite – le modèle adapté est déjà recommandé.' },
      text: { label: 'Texte', hint: 'Ajouter des noms de pièces ou des étiquettes.' },
    },
    editor: {
      tools: 'Outils',
      autoSuggest: 'Suggestions automatiques',
      analysis: 'Analyse de couverture',
      properties: 'Propriétés',
      backToIntro: 'Retour à l’aperçu du planificateur de caméras',
      resetTitle: 'Réinitialiser le planificateur?',
      resetText: 'Tous les éléments dessinés, les caméras et le plan importé seront définitivement supprimés. La planification enregistrée sera retirée.',
      cancel: 'Annuler',
      confirmReset: 'Oui, réinitialiser',
      close: 'Fermer',
      openTools: 'Ouvrir les outils',
      openAnalysis: 'Ouvrir l’analyse',
      snap: 'Activer/désactiver l’aimantation à la grille',
      zoomIn: 'Zoom avant',
      zoomOut: 'Zoom arrière',
      fit: 'Centrer le plan',
      closeHints: 'Fermer les conseils',
    },
    canvas: {
      areaLabel: 'Surface de dessin du plan',
      calibHint: 'Veuillez définir une distance pour la mise à l’échelle',
      locked: 'verrouillé',
      scale: 'Échelle : env. {{px}} px/m · Grille {{step}} m',
      calibNotice: 'Cliquez sur deux points du plan dont vous connaissez la distance.',
    },
    props: {
      edit: 'Modifier les propriétés',
      delete: 'Supprimer',
      cameraModel: 'Modèle de caméra (appareil réel)',
      nameNumber: 'Nom / numéro',
      cameraCategory: 'Catégorie de caméra',
      modelAssigned: 'Le modèle « {{series}} » est attribué.',
      planningValues: 'Ce sont des valeurs de planification, pas des données techniques d’un produit réel.',
      visibility: 'Visibilité',
      recognition: 'Reconnaissance',
      detail: 'Détail',
      rotation: 'Orientation (°)',
      fov: 'Angle de vision (°)',
      range: 'Portée (m)',
      posX: 'Position X (m)',
      posY: 'Position Y (m)',
      mountHeight: 'Hauteur de montage (m)',
      indoor: 'Intérieur',
      outdoor: 'Extérieur',
      usage: 'Domaine d’utilisation',
      dayNight: 'Jour / nuit',
      target: 'Cible de surveillance souhaitée',
      noneAssigned: 'Aucune attribuée',
      targetArea: 'Zone cible',
      remark: 'Remarque',
      remarkPlaceholder: 'ex. indications sur le montage ou l’environnement...',
      coneNote: 'Le cône de vision est une représentation de planification. La qualité réelle de l’image dépend du modèle, de l’objectif, de la distance, de la hauteur de montage, de la lumière et des obstacles sur place.',
      roomLabel: 'Désignation de la pièce',
      length: 'Longueur (m)',
      width: 'Largeur (m)',
      area: 'Surface : env. {{area}} m²',
      designation: 'Désignation',
      points: '{{count}} points – déplacez les points directement sur la surface de dessin.',
      wallThickness: 'Épaisseur du mur (m)',
      wallLength: 'Longueur : env. {{length}} m',
      wallNote: 'Les murs pleins limitent les lignes de vision dans le planificateur.',
      obstacleKind: 'Type d’obstacle',
      shape: 'Forme',
      rect: 'Rectangle',
      circle: 'Cercle',
      caption: 'Libellé',
      diameter: 'Diamètre (m)',
      depth: 'Profondeur (m)',
      goalKind: 'Type de cible',
      priority: 'Priorité',
      goal: 'Cible souhaitée',
      coverageNote: 'La couverture est évaluée par couleur (vert / jaune / rouge). Des exigences plus strictes s’appliquent aux cibles de détail.',
      zoneKind: 'Type de zone',
      privacyNote: 'Si un cône de vision chevauche cette zone, un avertissement apparaît dans l’analyse.',
      textContent: 'Contenu du texte',
      duplicate: 'Dupliquer',
      deleteElement: 'Supprimer l’élément',
      projectData: 'Données du projet',
      noElement: 'Aucun élément sélectionné',
      projectName: 'Nom du projet',
      objectType: 'Type de bien',
      objectTypePlaceholder: 'ex. maison individuelle',
      projectDescription: 'Description du projet',
      projectDescriptionPlaceholder: 'Particularités, souhaits ou conditions générales...',
      maxChars: 'Maximum 500 caractères',
      cameraForNew: 'Modèle de caméra pour les nouvelles caméras',
      cameraForNewDesc: 'Sélectionnez ci-dessous le modèle Safire souhaité; le menu s’ouvre automatiquement. Les nouvelles caméras sont placées avec ces réglages.',
      recommendedFor: 'Recommandé pour votre surface :',
      orGeneric: 'ou catégorie générique',
      tips: 'Conseils',
      tip1: 'Faire glisser une zone vide avec l’outil de sélection = déplacer la surface. Molette = zoom.',
      tip2: 'Ctrl+Z = annuler, Ctrl+Y = rétablir, Suppr = supprimer l’élément.',
      tip3: 'L’aimantation à la grille peut être activée/désactivée dans les options d’affichage.',
      suggestPositions: 'Suggérer automatiquement des positions de caméra',
      doorSwing: 'Sens d’ouverture',
      left: 'Gauche',
      right: 'Droite',
      none: 'Aucun',
      attached: 'Placée sur un mur – faites glisser le long du mur pour déplacer. La rotation libère l’élément.',
      detached: 'Placée librement – déplacez et faites pivoter librement.',
      doorNote: 'Le matériau, le vitrage et l’état d’ouverture doivent être vérifiés sur place.',
    },
    result: {
      edit: 'Modifier la planification',
      print: 'Imprimer le résumé',
      savePdf: 'Enregistrer en PDF',
      send: 'Envoyer la planification à SSG',
      eyebrow: 'Évaluation',
      title: 'Votre planification préliminaire en un coup d’œil',
      disclaimer:
        'Cette évaluation est une planification préliminaire non contraignante. Une recommandation définitive ne sera faite qu’après vérification des conditions locales et choix de la technologie de caméra concrète.',
      project: 'Projet',
      objectType: 'Type de bien :',
      uploadPresent: 'Import de plan disponible :',
      scaled: 'mis à l’échelle',
      refDistance: 'm de distance de référence',
      notScaled: 'pas encore mis à l’échelle',
      createdAt: 'Créé le',
      floorplan: 'Plan dessiné',
      noElements: 'Aucun élément dans le plan pour le moment.',
      stats: { rooms: 'Pièces et surfaces', walls: 'Murs', doors: 'Portes', windows: 'Fenêtres', obstacles: 'Obstacles', cameras: 'Caméras', zones: 'Zones cibles', privacy: 'Zones privées' },
      zonesTitle: 'Cibles de surveillance et priorités',
      noZones: 'Aucune cible de surveillance marquée.',
      priorityLabel: 'Priorité',
      goalLabel: 'Cible',
      goalOverview: 'Vue d’ensemble',
      goalDetail: 'Détail',
      goalObservation: 'Observation',
      coverage: 'couverture géométrique',
      camerasTitle: 'Positions et types de caméra',
      noCameras: 'Aucune caméra encore placée.',
      modelLabel: 'Modèle',
      fovLabel: 'Angle de vision',
      visibilityLabel: 'Visibilité env.',
      recognitionLabel: 'Reconnaissance env.',
      detailLabel: 'Détail env.',
      positionLabel: 'Position',
      rotationLabel: 'Orientation',
      rangeLabel: 'Portée env.',
      mountLabel: 'Hauteur de montage',
      indoor: 'Intérieur',
      outdoor: 'Extérieur',
      day: 'Jour',
      night: 'Nuit',
      dayNight: 'Jour et nuit',
      target: 'Cible',
      assigned: 'Attribuée',
      modelNote:
        'Les modèles Safire sélectionnés reposent sur des valeurs de fiche technique; visibilité/reconnaissance/détail sont des valeurs de planification calculées (EN 62676-4). Sans modèle, les valeurs sont génériques, pas des données techniques d’un produit réel.',
      blindTitle: 'Angles morts possibles et points ouverts',
      uncovered: 'Zones insuffisamment couvertes :',
      privacyOverlaps: 'Chevauchements avec des zones privées :',
      checkPrivacy: 'Vérifiez la position, l’orientation ou le masquage.',
      missingTitle: 'Informations importantes manquantes',
      quickTitle: 'Fonctions souhaitées et données du bien',
      areasLabel: 'Zones :',
      featuresLabel: 'Fonctions :',
      areaLabel: 'Surface :',
      recordingLabel: 'Enregistrement :',
      internetLabel: 'Internet :',
      powerLabel: 'Courant :',
      careInterest: 'Intérêt pour l’accompagnement SSG Care',
      finalNote: 'La planification sera vérifiée professionnellement par SSG Signaltechnik. Hauteur de montage, éclairage, angles et conditions sur place déterminent l’exécution finale.',
      sendBottom: 'Envoyer la planification à SSG Signaltechnik',
      consult: 'Demander un conseil personnel',
      good: 'Bien couvert',
      partial: 'Partiellement couvert',
      insufficient: 'Insuffisant',
    },
    send: {
      back: 'Retour',
      title: 'Envoyer la planification à SSG Signaltechnik',
      lead:
        'Vos données de planification (plan, caméras, angles de vision, cibles de surveillance, zones privées et résultat d’analyse) sont transmises avec vos coordonnées. Les coordonnées ne sont nécessaires que maintenant; la planification reste localement sur votre appareil.',
      dataTitle: 'Données de planification transmises',
      floorplan: 'Plan',
      rooms: 'Pièces/surfaces',
      walls: 'Murs',
      doors: 'Portes',
      windows: 'Fenêtres',
      obstacles: 'Obstacles',
      cameras: 'Caméras',
      none: 'aucune',
      zones: 'Cibles de surveillance',
      privacy: 'Zones privées',
      analysis: 'Analyse',
      good: 'bien',
      partial: 'partiel',
      insufficient: 'insuffisamment couvert',
      upload: 'Import de plan',
      scaled: 'mis à l’échelle',
      notScaled: 'non mis à l’échelle',
      customerType: 'Client particulier ou professionnel *',
      privateCustomer: 'Client particulier',
      businessCustomer: 'Client professionnel',
      name: 'Prénom et nom *',
      company: 'Entreprise (facultatif)',
      phone: 'Numéro de téléphone',
      email: 'Adresse e-mail *',
      projectAddress: 'Adresse du projet',
      projectAddressPlaceholder: 'Rue, code postal, ville',
      contactPref: 'Mode de contact préféré',
      any: 'Peu importe',
      byPhone: 'Téléphone',
      byEmail: 'E-mail',
      callbackTime: 'Créneau de rappel préféré',
      noCallback: 'Aucun rappel souhaité',
      morning: 'Matin',
      afternoon: 'Après-midi',
      evening: 'Soir',
      systemStatus: 'Nouvelle installation ou existante',
      newSystem: 'Nouvelle installation',
      existingSystem: 'Installation existante',
      unsure: 'Encore incertain',
      existingManufacturer: 'Fabricant d’une installation existante (si connu)',
      existingManufacturerPlaceholder: 'ex. Hikvision, Safire...',
      careInterest: 'Intérêt pour SSG Care',
      careYes: 'Oui, veuillez m’informer',
      careNo: 'Non',
      careLater: 'Décider plus tard',
      message: 'Message supplémentaire',
      messagePlaceholder: 'Compléments à votre planification...',
      fileUpload: 'Plan / photos (facultatif)',
      fileNote: 'Remarque : les envois de fichiers sont traités comme « Uncollectable »; les données de planification sont transmises sous forme de texte.',
      privacyConsent:
        'J’ai lu la politique de confidentialité et j’accepte le traitement de mes données pour le traitement de cette demande. Les données de planification sont utilisées exclusivement pour ce traitement. *',
      privacyLink: 'Politique de confidentialité',
      error: 'Une erreur est survenue. Veuillez réessayer plus tard.',
      networkError: 'Erreur réseau. Vérifiez votre connexion et réessayez.',
      successTitle: 'Merci pour votre planification.',
      successText: 'SSG Signaltechnik vérifiera vos données et vous contactera personnellement.',
      sending: 'Envoi en cours...',
      submit: 'Envoyer la planification à SSG',
      backToResult: 'Retour à l’évaluation',
    },
    tour: {
      stepOf: 'Étape {{current}} sur {{total}}',
      skip: 'Passer',
      back: 'Retour',
      next: 'Suivant',
      finish: 'C’est parti',
      dialogLabel: 'Introduction au planificateur de caméras',
      steps: {
        '0': { title: 'Bienvenue dans le planificateur de caméras SSG', text: 'Dessinez votre pièce ou importez un plan.' },
        '1': { title: 'Marquer les zones', text: 'Marquez les portes, fenêtres et zones importantes.' },
        '2': { title: 'Placer les caméras', text: 'Placez des caméras ou faites-vous suggérer des positions.' },
        '3': { title: 'Vérifier les champs de vision', text: 'Vérifiez les champs de vision et les angles morts possibles.' },
        '4': { title: 'Envoyer la planification', text: 'Envoyez la planification préliminaire à SSG Signaltechnik.' },
      },
    },
    analysis: {
      title: 'Analyse de couverture',
      suggest: 'Suggérer des positions',
      suggestTip: 'Suggérer des positions de caméra',
      cameras: 'Caméras',
      zones: 'Zones cibles',
      good: 'Bien couvert',
      partial: 'Partiel',
      notCovered: 'Non couvert',
      privacyConflict: 'Conflit de zone privée',
      areaCoverage: 'Couverture géométrique de la surface',
      areaNote: 'Couverture représentée géométriquement – aucune indication sur la qualité réelle d’image ou de reconnaissance.',
      legend: 'Légende',
      legendFov: 'Champ de vision de caméra',
      legendDetail: 'Reconnaissance de détail nette (pointillés)',
      legendGood: 'Cible bien couverte',
      legendPartial: 'Cible partiellement couverte',
      legendBad: 'Cible insuffisante',
      legendPrivacy: 'Zone privée / exclue',
      note: 'L’évaluation par couleur est une orientation géométrique. Un angle de vision large ne signifie pas automatiquement une reconnaissance de détail suffisante; distance, résolution et hauteur de montage doivent être vérifiées.',
    },
    upload: {
      title: 'Importer un plan',
      desc: 'Facultatif : importez un plan existant (JPG, PNG ou WebP) comme arrière-plan. Marquez ensuite une distance connue et saisissez sa longueur pour que le planificateur soit correctement mis à l’échelle.',
      choose: 'Sélectionner le plan',
      chooseOther: 'Choisir une autre image',
      remove: 'Supprimer',
      calibPrompt: 'Cliquez maintenant sur le point A et le point B du plan dans la surface de dessin.',
      startCalib: 'Lancer la mise à l’échelle',
      scaled: 'Mis à l’échelle : {{cm}} cm par pixel · Distance {{m}} m',
      lengthPlaceholder: 'Longueur en mètres',
      apply: 'Appliquer',
      opacity: 'Opacité {{pct}} %',
      lock: 'Verrouiller l’arrière-plan (empêche tout déplacement accidentel)',
      moveHint: 'Pour déplacer : faites glisser un endroit vide de l’image avec l’outil de sélection (si non verrouillé).',
      privacyNote: 'Les plans et photos du bien peuvent contenir des informations sensibles. N’importez que les fichiers nécessaires au traitement de votre demande.',
      onlyImages: 'Veuillez ne sélectionner que des images JPG, PNG ou WebP.',
      tooLarge: 'Le fichier est trop volumineux. Choisissez une image de moins de 8 Mo.',
      readError: 'Le fichier n’a pas pu être lu.',
      validLength: 'Veuillez saisir une longueur valide en mètres.',
      tooClose: 'Les points marqués sont trop proches.',
    },
    picker: {
      generic: 'Sélectionner une catégorie générique',
      genericOption: 'Catégorie générique (sans modèle)',
      recommended: 'Recommandé',
      recommendation: 'Recommandation pour votre surface',
      fovLabel: 'Angle de vision',
      detailFrom: 'Détail à partir d’env. {{detail}} m · Reconnaissance env. {{recognition}} m',
      hFov: 'Angle de vision horizontal',
      vFov: 'Angle de vision vertical',
      resolution: 'Résolution',
      lens: 'Objectif',
      irRange: 'Portée IR',
      ipClass: 'Classe de protection',
      audio: 'Audio',
      dayNight: 'Jour / nuit',
      datenblatt: 'Fiche technique',
      planungswert: 'Valeur de planification',
      doriNote:
        'Visibilité/reconnaissance/détail : valeurs de planification calculées selon EN 62676-4 (densité de pixels). La qualité réelle de l’image dépend du modèle, de l’objectif, de la hauteur de montage, de la lumière et des obstacles sur place.',
      groups: { standard: 'Standard / intérieur et extérieur', outdoor: 'Extérieur', panorama180: 'Panorama', ptz: 'Panoramique / zoom' },
    },
    quickswitch: {
      title: 'Changer de modèle de caméra',
      subtitle: 'Changer directement de variante',
      active: 'Actif',
      recommended: 'Recommandé',
      note: 'Réglez l’orientation, la portée et la hauteur de montage dans le panneau de propriétés à droite.',
      close: 'Fermer la sélection de modèle',
    },
    elementTypes: {
      room: 'Pièce / surface',
      polygon: 'Surface libre',
      wall: 'Mur',
      door: 'Porte',
      window: 'Fenêtre',
      obstacle: 'Obstacle',
      watchzone: 'Cible de surveillance',
      privacy: 'Zone privée / exception',
      camera: 'Caméra',
      text: 'Texte',
    },
    defaults: { room: 'Pièce', watchzone: 'Zone cible', text: 'Nom de pièce' },
    defaultProject: 'Ma planification de caméras',
    quickProject: 'Planification de caméras (vérification rapide)',
    options: {
      objectTypes: {
        Einfamilienhaus: 'Maison individuelle',
        Mehrfamilienhaus: 'Immeuble d’habitation',
        Wohnung: 'Appartement',
        'Ladengeschäft': 'Commerce',
        'Büro oder Praxis': 'Bureau ou cabinet',
        Gastronomie: 'Restauration',
        'Lager oder Logistik': 'Entrepôt ou logistique',
        Werkstatt: 'Atelier',
        'Parkplatz oder Außenfläche': 'Parking ou surface extérieure',
        Baustelle: 'Chantier',
        Sonstiges: 'Autre',
      },
      areas: {
        Haupteingang: 'Entrée principale',
        Nebeneingang: 'Entrée secondaire',
        Fenster: 'Fenêtre',
        Einfahrt: 'Accès',
        Garage: 'Garage',
        'Garten oder Terrasse': 'Jardin ou terrasse',
        Kasse: 'Caisse',
        Verkaufsfläche: 'Surface de vente',
        Lager: 'Entrepôt',
        Lieferzone: 'Zone de livraison',
        Parkplatz: 'Parking',
        'Büro oder Innenraum': 'Bureau ou intérieur',
        'Gesamte Außenfläche': 'Toute la surface extérieure',
        'Sonstiger Bereich': 'Autre zone',
      },
      features: {
        'Live-Ansicht': 'Affichage en direct',
        'lokale Aufzeichnung': 'Enregistrement local',
        'Smartphone-Zugriff': 'Accès smartphone',
        'Wiedergabe gespeicherter Aufnahmen': 'Lecture des enregistrements sauvegardés',
        Ereignisbenachrichtigungen: 'Notifications d’événements',
        'gute Sicht bei Dunkelheit': 'Bonne visibilité dans l’obscurité',
        'Übersicht über eine große Fläche': 'Vue d’ensemble d’une grande surface',
        'Erkennung wichtiger Details': 'Reconnaissance de détails importants',
        'mehrere Benutzer': 'Plusieurs utilisateurs',
        'mehrere Standorte': 'Plusieurs sites',
        'vorhandene Anlage erweitern': 'Étendre l’installation existante',
        'SSG-Care-Betreuung': 'Accompagnement SSG Care',
      },
      recordingDurations: {
        'Bis 7 Tage': 'Jusqu’à 7 jours',
        'Bis 14 Tage': 'Jusqu’à 14 jours',
        'Bis 30 Tage': 'Jusqu’à 30 jours',
        'Mehr als 30 Tage': 'Plus de 30 jours',
        'noch unklar': 'encore incertain',
      },
      roomNames: {
        Eingang: 'Entrée',
        Flur: 'Couloir',
        Wohnzimmer: 'Salon',
        'Büro': 'Bureau',
        Verkaufsfläche: 'Surface de vente',
        Kasse: 'Caisse',
        Lager: 'Entrepôt',
        Werkstatt: 'Atelier',
        Parkplatz: 'Parking',
        Außenbereich: 'Zone extérieure',
      },
      obstacles: {
        saeule: 'Colonne',
        regal: 'Étagère',
        trennwand: 'Cloison haute',
        moebel: 'Bloc de meubles',
        fahrzeug: 'Place de véhicule',
        eigen: 'Obstacle nommé',
      },
      watchKinds: {
        ueberblick: 'Surveiller entièrement la zone',
        eingang: 'Observer l’entrée',
        tuer: 'Surveiller la porte',
        fenster: 'Surveiller la fenêtre',
        kasse: 'Capter la caisse ou un point sensible',
        zufahrt: 'Observer l’accès',
        kennzeichen: 'Contrôler la zone de plaques',
        flaeche: 'Vue d’ensemble d’une surface',
        details: 'Reconnaître des détails importants',
        individuell: 'Zone individuelle',
      },
      watchPriorities: { normal: 'Normale', wichtig: 'Importante', kritisch: 'Critique' },
      watchGoals: { uebersicht: 'Vue d’ensemble', beobachtung: 'Observation', detail: 'Détail' },
      privacyKinds: {
        privat: 'Zone privée',
        nachbar: 'Terrain voisin',
        oeffentlich: 'Trottoir ou rue publique',
        mitarbeiter: 'Zone du personnel',
        ausgeschlossen: 'Zone à ne pas capter',
      },
      categories: {
        standard: { label: 'Caméra standard', hint: 'Polyvalente pour intérieur et extérieur' },
        wide: { label: 'Caméra grand-angle', hint: 'Vue large à courte/moyenne distance' },
        varifocal: { label: 'Caméra à angle variable', hint: 'L’angle est réglé sur place' },
        panorama180: { label: 'Caméra panoramique 180°', hint: 'Capture très large, reconnaissance de détail limitée' },
        fisheye360: { label: 'Caméra 360° / fisheye', hint: 'Vue panoramique, image corrigée électroniquement' },
        ptz: { label: 'Caméra PTZ', hint: 'Caméra panoramique/inclinable/zoom pour grandes surfaces' },
        indoor: { label: 'Caméra intérieure', hint: 'Optimisée pour les intérieurs' },
        outdoor: { label: 'Caméra extérieure', hint: 'Version résistante aux intempéries pour l’extérieur' },
      },
      dayNight: { tag: 'Jour', nacht: 'Nuit', beides: 'Jour et nuit' },
    },
    models: {
      'safire-turret-i1-4mp': { ai: 'Classification personnes et véhicules (IA)', note: 'Caméra turret polyvalente avec grand angle de vision – un bon standard pour l’intérieur et l’extérieur.' },
      'safire-turret-e1-4mp': { ai: 'Classification personnes et véhicules (IA)', note: 'Modèle d’entrée abordable de la série E1 avec une résolution solide.' },
      'safire-turret-b1-4mp': { ai: '', note: 'Turret économique robuste avec boîtier résistant aux chocs (IK10).' },
      'safire-dome-i2-8mp': { ai: 'Classification personnes et véhicules (IA)', note: 'Haute résolution 8 MP – plus de détail dans la même section d’image.' },
      'safire-bullet-4mp': { ai: 'Classification personnes et véhicules (IA)', note: 'Design bullet classique pour montage extérieur. Angle de vision comme valeur de planification selon la série.' },
      'safire-turret-nightcolor-4mp': { ai: 'Image couleur dans l’obscurité (NightColor X)', note: 'Fournit une image couleur même en faible lumière – idéal pour les situations nocturnes critiques. Angle de vision comme valeur de planification.' },
      'safire-turret-duallight-4mp': { ai: 'Classification personnes et véhicules (IA)', note: 'DualLight avec LED IR et lumière blanche (30 m chacune) – flexible la nuit. Angle de vision comme valeur de planification.' },
      'safire-panorama-180-8mp': { ai: 'Vue panoramique 180° avec haut-parleur et micro', note: 'Capture une zone très large avec une caméra – la reconnaissance de détail à distance est limitée.' },
      'safire-miniptz-4mp': { ai: 'Suivi automatique, classification personnes et véhicules', note: 'Caméra PTZ avec suivi automatique. Angle de vision comme valeur de planification (position finale grand-angle).' },
      'safire-ptz-15x-2mp': { ai: 'Suivi automatique, suivi des voitures et véhicules', note: 'Grande portée grâce au zoom 15× et à l’IR de 200 m. Angle de vision comme valeur de planification (position finale grand-angle).' },
    },
    disclaimer: {
      general:
        'Le planificateur de caméras fournit une planification préliminaire non contraignante. La section d’image réelle et la position adaptée dépendent entre autres du modèle, de l’objectif, de la distance, de la hauteur de montage, de l’éclairage, des obstacles et des conditions sur place.',
      result:
        'Cette évaluation est une planification préliminaire non contraignante. Une recommandation définitive ne sera faite qu’après vérification des conditions locales et choix de la technologie concrète.',
      upload: 'Les plans et photos du bien peuvent contenir des informations sensibles. N’importez que les fichiers nécessaires au traitement de votre demande.',
      sichtfeld: 'Les portes et fenêtres peuvent influencer les lignes de vision. Matériau, vitrage, état d’ouverture et reflets doivent être vérifiés sur place.',
      datenschutz:
        'Pour des exigences comme la reconnaissance faciale, l’identification de personnes ou la reconnaissance de plaques, une vérification technique et de protection des données est requise.',
    },
    hints: {
      '0':
        'D’après vos informations, plusieurs positions ou types de caméra peuvent convenir. Pour une recommandation fiable, angles de vision, hauteur de montage, éclairage et obstacles existants doivent être vérifiés.',
      '1':
        'Un angle de vision large ne signifie pas automatiquement une reconnaissance de détail suffisante. Distance, résolution, angle, hauteur de montage et cible influencent la qualité réelle de l’image.',
      '2': 'La hauteur de montage et les conditions d’éclairage doivent être vérifiées sur place.',
    },
    recommend: {
      noArea: 'Recommandation standard tant qu’aucune surface n’a été dessinée. Dessinez votre pièce et la recommandation s’ajustera.',
      veryLarge: 'Très grande surface (env. {{area}} m²) – PTZ avec zoom et grande portée pour les grandes distances.',
      large: 'Grande surface (env. {{area}} m²) – design bullet robuste pour l’extérieur.',
      medium: 'Surface moyenne à grande (env. {{area}} m²) – 8 MP pour plus de détail en largeur.',
      compact: 'Surface compacte (env. {{area}} m²) – un grand angle de vision couvre bien la pièce.',
    },
    analysisDynamic: {
      missingNoCameras: 'Aucune caméra encore placée.',
      missingNoRooms: 'Aucune pièce ou surface encore dessinée.',
      missingNoWalls: 'Aucun mur dessiné – les cônes de vision ne sont pas limités.',
      missingNoZones: 'Aucune cible de surveillance marquée.',
      missingNoPrivacy: 'Aucune zone privée ou d’exclusion marquée.',
      missingNoInternet: 'Information sur la connexion internet manquante.',
      missingNoPower: 'Information sur l’alimentation électrique manquante.',
      hintUncovered: 'Zones cibles sans couverture suffisante : vérifiez les positions ou prévoyez des caméras supplémentaires.',
      hintPartial: 'Certaines zones cibles ne sont que partiellement couvertes – ajustez l’angle, la position ou la portée.',
      hintDetailRange: 'La portée de détail de « {{name}} » (env. {{range}} m) ne suffit probablement pas seule pour les grandes pièces – une caméra supplémentaire pourrait être utile.',
      hintPrivacy: 'Le champ de vision chevauche une zone privée marquée. Position, orientation ou masquage technique doivent être vérifiés.',
      hintMount: 'La hauteur de montage et les conditions d’éclairage doivent être vérifiées sur place.',
      hintKennzeichen: 'Vérification technique et de protection des données requise.',
      noteDetailRange:
        'La reconnaissance de détail ne suffit probablement pas pour env. {{distance}} m de distance – détail max. env. {{identification}} m. Un angle plus étroit ou un modèle à plus haute résolution devrait être vérifié.',
      noteDetailUncertain: 'La reconnaissance de détail sur de plus grandes distances est incertaine – un angle plus étroit et la hauteur de montage doivent être vérifiés.',
      notePartial: 'Cette zone pourrait n’être que partiellement couverte.',
      suggestNear: 'La cible de surveillance « {{target}} » est proche de « {{privacy}} ». Position et orientation doivent être choisies avec soin – vérification de protection des données requise.',
      suggestHeuristic: 'Les suggestions sont heuristiques. Chaque caméra peut être déplacée, pivotée, modifiée ou supprimée librement.',
      suggestWide: 'Un angle de vision large ne signifie pas une reconnaissance de détail suffisante. Distance, résolution et hauteur de montage influencent la qualité de l’image.',
      cameraNoteDetail: 'Première position de caméra possible – prévoyez un angle plus étroit pour les cibles de détail.',
      cameraNoteCheck: 'Première position de caméra possible – veuillez vérifier et ajuster.',
      cameraSuggestion: 'Suggestion {{count}}',
      uncoveredPartial: 'partiel',
      uncoveredInsufficient: 'insuffisant',
      toastNoPositions: 'Aucune nouvelle position trouvée. Ajoutez des cibles de surveillance ou des pièces.',
      toastSuggested: '{{count}} première(s) position(s) de caméra possible(s) suggérée(s).',
    },
  },
};